<div class="responsive-card">
  <div class="d-flex flex-column gap-4">
    <div class="d-flex flex-column gap-2">
      <div class="responsive-card-title" i18n>Withdrawal Details</div>
      <div class="responsive-card-description mb-3" i18n>
        The payments will be made with the withdrawal percentages outlined below. If one fund depletes its balance, the
        withdrawal instructions will convert entirely to the other fund.
      </div>

      <div class="withdrawal-instructions-grid">
        <ng-container *ngIf="sortedInstructions$ | async as sortedInstructions">
          <app-vb-review-withdrawal-details-withdrawal-instruction
            class="instruction-item"
            *ngFor="let fg of sortedInstructions"
            [fundType]="fg?.controls?.fund?.value | fundTypeById : fundTypes"
            [balance]="fg?.controls?.balance?.value"
            [percentage]="fg?.controls?.percentage?.value" />
        </ng-container>
      </div>
    </div>
  </div>
</div>
